import { connect } from 'react-redux';
import Home from 'src/ui/features/Home/components/Home';

const mapStateToProps = ({ login }) => ({
  loginData: login,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
